export const categories = [
  {
    id: 1,
    name: "电视剧",
    slug: "tv-series",
    icon: "ri-tv-line",
    count: 128,
    description: "海量高清电视剧，涵盖古装、都市、悬疑、爱情等多种类型，每日更新最新剧集。",
  },
  {
    id: 2,
    name: "电影",
    slug: "movies",
    icon: "ri-film-line",
    count: 256,
    description: "最新院线大片、经典老片、国产佳作、好莱坞巨制，应有尽有。",
  },
  {
    id: 3,
    name: "综艺",
    slug: "variety",
    icon: "ri-emotion-laugh-line",
    count: 89,
    description: "热门综艺节目，搞笑、音乐、竞技、真人秀，陪你度过欢乐时光。",
  },
  {
    id: 4,
    name: "动漫",
    slug: "anime",
    icon: "ri-aliens-line",
    count: 312,
    description: "国产动漫、日本动漫、欧美动漫，二次元世界精彩纷呈。",
  },
  {
    id: 5,
    name: "纪录片",
    slug: "documentary",
    icon: "ri-camera-lens-line",
    count: 45,
    description: "自然、历史、科技、人文纪录片，带你探索世界的奥秘。",
  },
  {
    id: 6,
    name: "少儿",
    slug: "kids",
    icon: "ri-bear-smile-line",
    count: 67,
    description: "益智动画、儿童教育、亲子节目，陪伴孩子快乐成长。",
  },
];

export const sources = [
  { name: "香蕉视频", slug: "banana", color: "bg-accent-500" },
  { name: "糖豆视频", slug: "candy", color: "bg-primary-500" },
  { name: "小蓝视频", slug: "xiaolan", color: "bg-secondary-500" },
  { name: "蓝莓视频", slug: "blueberry", color: "bg-accent-300" },
];